module.exports = __webpack_public_path__ + "static/media/spiky_dj_tag_3.9610c518.mp3";